import { ChainType } from "../constants/enum/enum";
import configBsc from "./config.bsc";
import configPulseChain from "./config.pulsechain";

export const CHAIN =
  import.meta.env.VITE_CHAIN === ChainType.PLS ? ChainType.PLS : ChainType.BNB;

const config = CHAIN === ChainType.PLS ? configPulseChain : configBsc;

export const SERVER_URL = config.serverEndpoint;
export const ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";

export default config;
